import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

/**
 * Max / default public-link expiration as a calendar day.
 * DatePicker is date-only; keeping wall-clock time from `add(N, 'day')` exceeds the
 * backend day bound (re-picking the same max day sends start-of-day and succeeds).
 */
export function publicLinkExpirationDayjs(maxExpirationDays: number, from: Dayjs = dayjs()): Dayjs {
  return from.add(maxExpirationDays, 'day').startOf('day');
}
